import React from 'react'
import { Helmet } from 'react-helmet-async'

function Head({ title, metatitle, metaDescription }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="keywords" content={metatitle} />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metatitle} />
      <meta property="og:description" content={metaDescription} />
    </Helmet>
  )
}

export default Head
